import { Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { createVariablesRecord } from '@core/models/block.model';
import {
  BlockCommon,
  BlockCommonDataInterface,
  BlockVariables,
} from '@shared/interfaces/block.interface';
import { ContentBuilderVariablesService } from '@shared/utils/content-builder-variables/content-builder-variables.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-html-block',
  templateUrl: './html-block.component.html',
  template: ``,
})
export class HtmlBlockComponent implements BlockCommonDataInterface {
  private readonly contentBuilderVariablesService = inject(ContentBuilderVariablesService);
  protected readonly blockVariables = computed(() => this.common()?.variables ?? []);

  readonly html = input<string>();

  readonly common = input<BlockCommon>();
  private readonly inputs = computed(() => ({
    html: this.html(),
    variables: this.blockVariables(),
  }));

  protected readonly parsedHtml = toSignal(
    toObservable(this.inputs).pipe(
      switchMap(({ html, variables }) => {
        return this.parseContentBuilderVariables$(html ?? '', variables);
      }),
    ),
  );

  protected readonly parseContentBuilderVariables$ = (html: string, variables: BlockVariables) => {
    return this.contentBuilderVariablesService.parseContentBuilderString$(
      html,
      createVariablesRecord(variables),
    );
  };
}
